export const servicesSlides = [
  {
    shortTitle: "Community",
    title: "Community Management and Moderation",
    slides: [
      {
        title:
          "Community creation, setup and management for Discord, Telegram and related platforms",
        image: "services/1.png",
      },
      {
        title:
          "Implementation of role structures, permissions, and community guidelines",
        image: "services/2.png",
      },
      {
        title:
          "Moderator and Community Staff training with in-house resources and platforms",
        image: "services/3.png",
      },
      {
        title:
          "Coordination of moderation and operative support teams in real time",
        image: "services/4.png",
      },
      {
        title: "Automatic AI powered moderation system",
        image: "services/5.png",
      },
      {
        title: "User activity, retention, and satisfaction monitoring",
        image: "services/6.png",
      },
    ],
  },
  {
    shortTitle: "Technology",
    title: "Technology Development and Automation",
    slides: [
      {
        title:
          "Development of custom bots tailored to the objectives of each community or brand",
        image: "services/7.png",
      },
      {
        title:
          "Creation of administrative dashboards for internal management and reports",
        image: "services/8.png",
      },
      {
        title:
          "AI and machine learning integration for automated support and behavioral analysis",
        image: "services/9.png",
      },
      {
        title:
          "Development of mini-apps and interactive dashboards connected to communities and programs",
        image: "services/10.png",
      },
    ],
  },
  {
    shortTitle: "Experience",
    title: "Digital Experience and Engagement",
    slides: [
      {
        title:
          "Interaction and engagement strategies for users and community members",
        image: "services/11.png",
      },
      {
        title: "Development of activities, trivia and challenges",
        image: "services/12.png",
      },
      {
        title: "Planning and execution of brand-focused community events",
        image: "services/13.png",
      },
    ],
  },
  {
    shortTitle: "Analytics",
    title: "Growth Tracking and Reporting",
    slides: [
      {
        title: "Custom KPI definition based on client or project objectives",
        image: "services/14.png",
      },
      {
        title: "Development of automated reports and dynamic dashboards",
        image: "services/15.png",
      },
      {
        title: "Advanced engagement, retention and conversion analytics",
        image: "services/16.png",
      },
    ],
  },
  {
    shortTitle: "Loyalty",
    title: "Monetization and Loyalty Programs",
    slides: [
      {
        title:
          "Sustainable monetization strategy design for communities and bots",
        image: "services/10.png",
      },
      {
        title: "Subscription, membership, and premium role setup",
        image: "services/17.png",
      },
    ],
  },
];
